// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"22ed6dc4","219":"81d5becd","267":"d394ed4f","453":"f86835ca","567":"81b8c825","604":"ddfe17f2","620":"211e286b","644":"a3a6bad8","664":"987b7980","667":"91cdfb19"}[chunkId] + ".chunk.js";
};